export const sidebarTranslations = {
  en: {
    home: "Home",
    athletesList: "Athletes List",
    managerList: "Manager List",
    pendingmember: "Pending Users",
    readyRoster: "Ready Roster",
    opportunities: "Opportunities",
    chat: "Chat",
    history: "History",
    abuseReport: "Abuse Report",
    settings: "Settings",
    logout: "Logout",
    viewProfile: "View Profile",
    mydeals: "Dispute Deals",
    feeds:"Feeds",
    marketplaceCards: "Marketplace Cards",
  },
  de: {
    home: "Startseite",
    athletesList: "Athletenliste",
    managerList: "Managerliste",
    pendingmember: "Ausstehende Mitglieder", 
    readyRoster: "Bereitschaftsroster",
    opportunities: "Möglichkeiten",
    chat: "Unterhaltung",
    history: "Verlauf",
    abuseReport: "Missbrauchsbericht",
    settings: "Einstellungen",
    logout: "Abmelden",
    viewProfile: "Profil ansehen",
    mydeals: "Streitfälle",
    feeds:"Beiträge",
    marketplaceCards: "Marktplatzkarten",
  },
  hr: {
    home: "Početna",
    athletesList: "Popis sportaša",
    managerList: "Popis menadžera",
    pendingmember: "Na čekanju članovi", 
    readyRoster: "Spremni popis",
    opportunities: "Prilike",
    chat: "Razgovor",
    history: "Povijest",
    abuseReport: "Izvještaj o zloupotrebi",
    settings: "Postavke",
    logout: "Odjava",
    viewProfile: "Prikaži profil",
    mydeals: "Sporni poslovi",
    feeds:"Objave",
    marketplaceCards: "Kartice tržišta", 
  },
};
